module.exports = __webpack_public_path__ + "img/questions.32bb8389.svg";